/*!jslint
  this
*/
jQuery(function ($) {
  "use strict";
  $(document).on("click", ".scroll-to", function(e) {
      var href = $(this).attr("href");
      var offsetTop = href === "#" ? 0 : $(href).offset().top;
      var HdTop = $(".site-header").outerHeight();
      $("html, body").stop().animate({
          scrollTop: offsetTop - HdTop
      }, 500);
      e.preventDefault();
    });
  $(document).on('click', '.nav-toggle', function(){
      $(this).toggleClass('on');
      $('html').toggleClass('nav-on');
    });
  
   function appHeight() {
      var wh = $(window).innerHeight();
      document.documentElement.style
        .setProperty('--app-height', wh + 'px');

    }
    window.addEventListener('resize', appHeight)
    appHeight();

    // Cache selectors
    if($('.verticals').length){
      var lastId,
          topMenu = $(".verticals-nav"),
          topMenuHeight = $(".site-header").outerHeight()+150,
          // All list items
          menuItems = topMenu.find("a"),
          // Anchors corresponding to menu items
          scrollItems = menuItems.map(function(){
            var item = $($(this).attr("href"));
            if (item.length) { return item; }
          });

      // Bind click handler to menu items
      // so we can get a fancy scroll animation
      menuItems.click(function(e){
        var href = $(this).attr("href"),
            offsetTop = href === "#" ? 0 : $(href).offset().top-topMenuHeight;
        $('html, body').stop().animate({ 
            scrollTop: offsetTop
        }, 300);
        e.preventDefault();
      });

      // Bind to scroll
        $(window).scroll(function(){
           // Get container scroll position
           var fromTop = $(this).scrollTop()+topMenuHeight;
           
           // Get id of current scroll item
           var cur = scrollItems.map(function(){
             if ($(this).offset().top < fromTop)
               return this;
           });
           // Get the id of the current element
           cur = cur[cur.length-1];
           var id = cur && cur.length ? cur[0].id : "";
           
           if (lastId !== id) {
               lastId = id;
               // Set/remove active class
               menuItems
                 .parent().removeClass("active")
                 .end().filter("[href='#"+id+"']").parent().addClass("active");
           }                   
        });
      }
    $(window).scroll(function () {
    var ST = $(this).scrollTop();

    if ($('.clip-image-plx').length) {

      $(".clip-image-plx").each(function (i) {
        var offset = 0.1;
        var OT = $(this).parents('.parallax-section').offset().top;
        if (ST >= OT - $(window).outerHeight()) {
          $(this).find('img').css({

            '-webkit-transform': 'translateY(' + -((ST - OT) * offset) + 'px) scale(1.2)',
            '-moz-transform': 'translateY(' + -((ST - OT) * offset) + 'px) scale(1.2)',
            '-ms-transform': 'translateY(' + -((ST - OT) * offset) + 'px) scale(1.2)',
            '-o-transform': 'translateY(' + -((ST - OT) * offset) + 'px) scale(1.2)',
            'transform': 'translateY(' + -((ST - OT) * offset) + 'px) scale(1.2)'
          });
        }
      });

    }
    if (ST >= 141) {
      $('.site-header').addClass('sticky');
    } else {
      $('.site-header').removeClass('sticky');
    }
  });

  $('.image-slider').slick({
    dots: false,
    infinite: true,
    arrows: true, 
    nextArrow: '<span class="slick-arrow slick-next"><svg width="23" height="23" viewBox="0 0 23 23" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin" fill="none"><g xmlns="http://www.w3.org/2000/svg" clip-path="url(#clip0_3_6)"><path fill="black" d="M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z"/></g><g xmlns="http://www.w3.org/2000/svg" clip-path="url(#clip1_3_6)"><path stroke="white" stroke-width="2" d="M7.522 6.85303L16.101 12.11L7.522 17.367"/></g><defs xmlns="http://www.w3.org/2000/svg"><clipPath id="clip0_3_6"><path fill="white" d="M0 0H23V23H0z"/></clipPath><clipPath id="clip1_3_6"><path fill="white" d="M0 0H11.016V12.219H0z" transform="translate(7 6)"/></clipPath></defs></svg></span>',
    prevArrow: '<span class="slick-arrow slick-prev"><svg width="23" height="23" viewBox="0 0 23 23" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin" fill="none"><g xmlns="http://www.w3.org/2000/svg" clip-path="url(#clip0_6_13)"><path fill="black" d="M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z"/><path stroke="white" stroke-width="2" d="M15.579 17.514L6.99998 12.257L15.579 7.00001"/></g><defs xmlns="http://www.w3.org/2000/svg"><clipPath id="clip0_6_13"><path fill="white" d="M0 0H23V23H0z"/></clipPath></defs></svg></span>',
  });
  $('.news-cards-cl').slick({
    dots: false,
    infinite: true,
    arrows: true, 
    nextArrow: '<span class="slick-arrow slick-next"><svg width="23" height="23" viewBox="0 0 23 23" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin" fill="none"><g xmlns="http://www.w3.org/2000/svg" clip-path="url(#clip0_3_6)"><path fill="black" d="M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z"/></g><g xmlns="http://www.w3.org/2000/svg" clip-path="url(#clip1_3_6)"><path stroke="white" stroke-width="2" d="M7.522 6.85303L16.101 12.11L7.522 17.367"/></g><defs xmlns="http://www.w3.org/2000/svg"><clipPath id="clip0_3_6"><path fill="white" d="M0 0H23V23H0z"/></clipPath><clipPath id="clip1_3_6"><path fill="white" d="M0 0H11.016V12.219H0z" transform="translate(7 6)"/></clipPath></defs></svg></span>',
    prevArrow: '<span class="slick-arrow slick-prev"><svg width="23" height="23" viewBox="0 0 23 23" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin" fill="none"><g xmlns="http://www.w3.org/2000/svg" clip-path="url(#clip0_6_13)"><path fill="black" d="M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z"/><path stroke="white" stroke-width="2" d="M15.579 17.514L6.99998 12.257L15.579 7.00001"/></g><defs xmlns="http://www.w3.org/2000/svg"><clipPath id="clip0_6_13"><path fill="white" d="M0 0H23V23H0z"/></clipPath></defs></svg></span>',
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
    });
  $('.videos-cl').slick({
    dots: true,
    infinite: true,
    arrows: true, 
    nextArrow: '<span class="slick-arrow slick-next"><svg width="23" height="23" viewBox="0 0 23 23" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin" fill="none"><g xmlns="http://www.w3.org/2000/svg" clip-path="url(#clip0_3_6)"><path fill="black" d="M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z"/></g><g xmlns="http://www.w3.org/2000/svg" clip-path="url(#clip1_3_6)"><path stroke="white" stroke-width="2" d="M7.522 6.85303L16.101 12.11L7.522 17.367"/></g><defs xmlns="http://www.w3.org/2000/svg"><clipPath id="clip0_3_6"><path fill="white" d="M0 0H23V23H0z"/></clipPath><clipPath id="clip1_3_6"><path fill="white" d="M0 0H11.016V12.219H0z" transform="translate(7 6)"/></clipPath></defs></svg></span>',
    prevArrow: '<span class="slick-arrow slick-prev"><svg width="23" height="23" viewBox="0 0 23 23" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin" fill="none"><g xmlns="http://www.w3.org/2000/svg" clip-path="url(#clip0_6_13)"><path fill="black" d="M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z"/><path stroke="white" stroke-width="2" d="M15.579 17.514L6.99998 12.257L15.579 7.00001"/></g><defs xmlns="http://www.w3.org/2000/svg"><clipPath id="clip0_6_13"><path fill="white" d="M0 0H23V23H0z"/></clipPath></defs></svg></span>',
    slidesToShow: 3,
    slidesToScroll: 3,
    centerMode: true,
    centerPadding: '0px',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
        }
      }
    ]
    });
/*  $('.ab-timeline-cl-main').slick({
    dots: false,
    infinite: true,
    arrows: false, 
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.ab-timeline-cl-sub'
    });
  $('.ab-timeline-cl-sub').slick({
    dots: false,
    infinite: false,
    arrows: false, 
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.ab-timeline-cl-main',
    variableWidth: true,
    centerMode: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          variableWidth: false,
          centerMode: false,
           slidesToShow: 1,
            slidesToScroll: 1,
        }
      }
    ]
    });*/
  $(window).on("resize", function () {
    
    setTimeout(function () {
           $('.ab-timeline-cl-main .slick-list').height($('.ab-timeline-cl-main .slick-track').innerHeight() * 2);
       }, 1000);
  }).resize();

  $(document).on('click', '.ab-timeline-cl-sub .slick-slide', function(){
    var number = $(this).data('slick-index');
    $('.ab-timeline-cl-main').slick('slickGoTo', number);
  });
  
  
    $(function () {
      AOS.init({
          easing: 'ease-in-out-sine',
          duration: 400,
          once: true
      });
    });
    $('.faq-item-title').click(function() {
      $('.faq-item-title').removeClass('on');
      $('.faq-item-content').slideUp('normal');
      if($(this).next().is(':hidden') == true) {
        $(this).addClass('on');
        $(this).next().slideDown('normal');
      }
    }); 
    $(document).on('click', '.videos-cl-item a', function(e){
      e.preventDefault();
      var videoURL = $(this).data('video');
      var videoTitle = $(this).data('title');
      var videoDesc = $(this).data('desc');
      $('#video-play-wrap').find('h3').html(videoTitle);
      $('#video-play-wrap').find('p').html(videoDesc);
      $('#video-play-wrap').find('iframe').attr('src', videoURL);
      var offsetTop = $('#videos').offset().top;
      var HdTop = $(".site-header").outerHeight();
      $("html, body").stop().animate({
          scrollTop: offsetTop
      }, 500);
      $('.videos-cl-item a').removeClass('active');
      $(this).addClass('active');
    });
    $(document).on('click', '.loadmore', function (e) {
        e.preventDefault();
        var $el = $(this),
          $tgt = $el.data('target'),
            link = $el.attr('href');
        if ($el.attr('disabled'))
            return;
        $el.addClass('loading').attr('disabled', true);
        $el.find('span').html('Loading...')
        $("<div>").load(link + $tgt, function () {
            $($tgt).append($(this).find($tgt).html());
            $el.parents('.load-more').removeAttr('disabled').remove();
        });
  });

    $(document).on('click', '.doc-list-filter ul a', function (e) {
        e.preventDefault();
        e.stopPropagation();
        
        var $el = $(this),
          $tgt = '#doc-list-main',
            link = $el.attr('href');
        var offsetTop = $($tgt).offset().top;
        var HdTop = $(".site-header").outerHeight();
        if ($el.attr('disabled'))
            return;
       $('body').addClass('loading');
        $("#doc-list-main").load(link + $tgt, function () {
            $($tgt).html($(this).find($tgt).html());
            $('body').removeClass('loading');
                         
        });
         window.history.pushState({
                href: link
            }, '', link);

         $("html, body").stop().animate({
              scrollTop: offsetTop - HdTop
          }, 100);
  });
    $(window).on('scroll', function(e){
      if($('.ab-timeline').length){
        var ST = $(this).scrollTop();
        var IT = $('.ab-timeline').offset().top;
        var WH = $(this).height();
        var IH = $('.ab-timeline').outerHeight();
        var BP = IT+IH-WH-100;
        if(ST >= IT - 100 && ST <= BP){
          $('.ab-timeline-nav').addClass('sticky');
        }else{
          $('.ab-timeline-nav').removeClass('sticky');
        }
      }
    });

    if($('.ab-timeline').length){
      var lastId,
          topMenu = $(".ab-timeline-nav"),
          topMenuHeight = $(".site-header").outerHeight(),
          // All list items
          menuItems = topMenu.find("a"),
          // Anchors corresponding to menu items
          scrollItems = menuItems.map(function(){
            var item = $($(this).attr("href"));
            if (item.length) { return item; }
          });

      // Bind click handler to menu items
      // so we can get a fancy scroll animation
      menuItems.click(function(e){
        var href = $(this).attr("href"),
            offsetTop = href === "#" ? 0 : $(href).offset().top-topMenuHeight;
        $('html, body').stop().animate({ 
            scrollTop: offsetTop
        }, 300);
        e.preventDefault();
      });

      // Bind to scroll
        $(window).scroll(function(){
           // Get container scroll position
           var fromTop = $(this).scrollTop()+topMenuHeight + 30;
           
           // Get id of current scroll item
           var cur = scrollItems.map(function(){
             if ($(this).offset().top < fromTop)
               return this;
           });
           // Get the id of the current element
           cur = cur[cur.length-1];
           var id = cur && cur.length ? cur[0].id : "";
           
           if (lastId !== id) {
               lastId = id;
               // Set/remove active class
               menuItems
                 .parent().removeClass("active")
                 .end().filter("[href='#"+id+"']").parent().addClass("active");
           }                   
        });
      }
});